// extracted by mini-css-extract-plugin
export default {"container":"SearchBarAccordion_container__3YJeZ"};